<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace" id="epigraph"> </p>
<p class="v">“Someday</p>
<p class="v">after we have mastered the</p>
<p class="v">winds and the tides and the waves</p>
<p class="v">and the gravity</p>
<p class="v">we will harness for God</p>
<p class="v">the energies of love:</p>
<p class="v">and then for the second time</p>
<p class="v">in the history of the world</p>
<p class="vsb">men will have discovered fire.”</p>
<p class="v">     <span class="epub-i">Pierre Teilhard de Chardin</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?75e9afc6